import request from '@/axios'

/**
 * @Description: 获取应用软件推荐
 */
export function getSortApp(data){
  return request({
    method: 'post',
    url: '/api/Applys/selectApplysListByApplystypeId',
    params: data
  })
}
